import { I18n } from '@calendly/i18n';
import { FullStoryExclude } from '@calendly/ui/components/fullstory-privacy';
import { Link } from '@calendly/ui/components/link';
import { BodyText, TitleText } from '@calendly/ui/components/typography';
import { useState } from 'react';
import { useGetUserQuery } from 'common';
import { Header, GrowableSearchSection, ChatSuggestions, SUGGESTED_PROMPTS, COMPOSER_LOCATION, QUERY_SOURCE_TYPE } from 'components/agent_hub_components';
import { AI_EMBEDDED_DISCLAIMER_LEARN_MORE_URL } from 'features/agent_hub/ai_chat_discovery/constants';
import styles from './AISearchPage.module.css';
const greetingTitleCss = "g17te055";
const firstNameFromUserName = name => {
  if (!name || typeof name !== 'string') return '';
  const part = name.trim().split(/\s+/)[0];
  return part ?? '';
};
export const AISearchPage = ({
  handleSearch = () => {},
  analyticsHandlers = {},
  embedded = false
}) => {
  const [searchQuery, setSearchQuery] = useState('');
  const {
    data: userData
  } = useGetUserQuery(undefined, {
    skip: !embedded
  });
  const handlePromptClick = prompt => {
    if (analyticsHandlers.trackSearchSubmitted) {
      analyticsHandlers.trackSearchSubmitted(COMPOSER_LOCATION.HOME_PAGE, QUERY_SOURCE_TYPE.SUGGESTION);
    }
    handleSearch(prompt, QUERY_SOURCE_TYPE.SUGGESTION);
  };
  const handleSearchWithAnalytics = query => {
    if (analyticsHandlers.trackSearchSubmitted) {
      analyticsHandlers.trackSearchSubmitted(COMPOSER_LOCATION.HOME_PAGE, QUERY_SOURCE_TYPE.TEXT);
    }
    handleSearch(query, QUERY_SOURCE_TYPE.TEXT);
  };
  const suggestionsBlock = <>
      {!embedded && <BodyText weight="bold" color="muted">
        {I18n.t('publisher.agent_hub.suggest_prompts_heading')}
      </BodyText>}
      <ChatSuggestions chatSuggestions={SUGGESTED_PROMPTS} onSuggestionClick={handlePromptClick} embedded={embedded} />
    </>;
  const searchSection = <FullStoryExclude>
      <GrowableSearchSection searchQuery={searchQuery} onSearchChange={setSearchQuery} onSearch={handleSearchWithAnalytics} location={COMPOSER_LOCATION.HOME_PAGE} includeWhiteFade={false} analyticsHandlers={analyticsHandlers} embedded={embedded} />
    </FullStoryExclude>;
  if (embedded) {
    const firstName = firstNameFromUserName(userData?.name);
    const greetingText = firstName ? I18n.t('publisher.agent_hub.embedded_search.greeting', {
      first_name: firstName
    }) : I18n.t('publisher.agent_hub.embedded_search.greeting_fallback');
    return <div className={styles.containerEmbedded}>
        <div className={styles.mainContentEmbedded}>
          <div>
            <h2 className={greetingTitleCss}>{greetingText}</h2>
            <TitleText size="large" level={2}>
              {I18n.t('publisher.agent_hub.embedded_search.help_prompt')}
            </TitleText>
          </div>

          <div className={styles.chatSuggestionsContainerEmbedded}>
            {suggestionsBlock}
          </div>

          {searchSection}
        </div>
        <div className={styles.embeddedDisclaimer}>
          <BodyText color="muted" size="small">
            {I18n.t('publisher.agent_hub.disclaimer')}
            {' '}
            <Link href={AI_EMBEDDED_DISCLAIMER_LEARN_MORE_URL} target="_blank" rel="noopener noreferrer" className={styles.embeddedDisclaimerLearnMore}>
              {I18n.t('publisher.agent_hub.embedded_search.learn_more')}
            </Link>
          </BodyText>
        </div>
      </div>;
  }
  return <div className={styles.container}>
      <div className={styles.mainContent}>
        <Header title={I18n.t('publisher.agent_hub.header.title')} subtitle={I18n.t('publisher.agent_hub.header.subtitle')} />

        {searchSection}

        <div className={styles.chatSuggestionsContainer}>
          {suggestionsBlock}
        </div>
      </div>
    </div>;
};

require("./AISearchPage.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./AISearchPage.js");